/** Stato dell'app codificato nell'hash dell'URL: link condivisibili. */

import type { LatLng } from './geo';

export interface PermalinkState {
  a?: LatLng;
  b?: LatLng;
  /** epoch ms della partenza; assente = "adesso" */
  t?: number;
  /** 'auto' oppure percentuale slider 0..100 */
  pref?: 'auto' | number;
}

const f = (v: number) => v.toFixed(5);

export function encodePermalink(s: PermalinkState): string {
  const params = new URLSearchParams();
  if (s.a) params.set('a', `${f(s.a.lat)},${f(s.a.lng)}`);
  if (s.b) params.set('b', `${f(s.b.lat)},${f(s.b.lng)}`);
  if (s.t !== undefined) params.set('t', String(Math.round(s.t)));
  if (s.pref !== undefined) params.set('p', String(s.pref));
  const q = params.toString();
  return q ? `#${q}` : '';
}

function parsePoint(v: string | null): LatLng | undefined {
  if (!v) return undefined;
  const m = v.split(',').map((x) => parseFloat(x));
  if (m.length !== 2 || m.some((n) => !Number.isFinite(n))) return undefined;
  if (Math.abs(m[0]) > 90 || Math.abs(m[1]) > 180) return undefined;
  return { lat: m[0], lng: m[1] };
}

export function decodePermalink(hash: string): PermalinkState | null {
  const raw = hash.startsWith('#') ? hash.slice(1) : hash;
  if (!raw) return null;
  let params: URLSearchParams;
  try {
    params = new URLSearchParams(raw);
  } catch {
    return null;
  }
  const state: PermalinkState = {};
  const a = parsePoint(params.get('a'));
  const b = parsePoint(params.get('b'));
  if (a) state.a = a;
  if (b) state.b = b;
  const t = params.get('t');
  if (t !== null) {
    const ms = parseInt(t, 10);
    if (Number.isFinite(ms) && ms > 0) state.t = ms;
  }
  const p = params.get('p');
  if (p === 'auto') state.pref = 'auto';
  else if (p !== null) {
    const pct = parseInt(p, 10);
    if (Number.isFinite(pct) && pct >= 0 && pct <= 100) state.pref = pct;
  }
  return Object.keys(state).length > 0 ? state : null;
}
